import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
  Store,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.actor}sellers/stores`;

export interface GetStoresQueryArgs {
  storeId: string;
}

export const getStoresRequest = ({
  storeId,
}: GetStoresQueryArgs): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT),
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { storeIds: storeId },
  },
});

export const getStoresQuery = async (
  payload: GetStoresQueryArgs,
): Promise<BackResponse<Store[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Store[]>>(
      getStoresRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
